<template>
    <div>
        <div v-show="!mostrarRateios">
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblCronogramaRecebimento"
                :itens="cronogramaRecebimento"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false">
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-cronograma-recebimento
                            v-if="$temAcessoView('CONV-REC-01')"
                            :convenio="convenio"
                            @atualizarLista="atualizarLista()">
                        </btn-inserir-cronograma-recebimento>
                    </b-button-group>
                </template>
                <template slot="nuValorRecebimento" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorRecebimento | currency }}
                    </p>
                </template>
                <template slot="dtMesAno" slot-scope="data">
                    <p class="text-left m-0">
                        {{ data.dtMesAno ? $moment(data.dtMesAno).format('MM/YYYY') : '' }}
                    </p>
                </template>
                <template slot="acoes" slot-scope="data">
                    <btn-atualizar-cronograma-recebimento
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-REC-02') && !data.comprometidoNoRm"
                        :convenio="convenio"
                        :cronogramaRecebimento="data"
                        @atualizarLista="atualizarLista()">
                    </btn-atualizar-cronograma-recebimento>
                    <btn-excluir-cronograma-recebimento
                        class="text-danger float-left mr-1"
                        v-if="$temAcessoView('CONV-REC-02') && !data.comprometidoNoRm"
                        :convenio="convenio"
                        :cronogramaRecebimento="data"
                        @atualizarLista="atualizarLista()"
                    ></btn-excluir-cronograma-recebimento>
                    <btn-mostrar-rateios
                        v-if="data.temComprometimento"
                        @atualizarComprometimento="comprometimento = $event"
                        :cronogramaRecebimento="data"
                    ></btn-mostrar-rateios>
                </template>
                <template slot="idRm" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.idRm }}
                    </p>
                </template>
                <template slot="statusComprometimento" slot-scope="data">
                    <app-status
                        :status="data.statusComprometimento">
                    </app-status>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarRateios">
            <rateios
                :convenio="convenio"
                :comprometimento="comprometimento"
                @atualizarCronograma="atualizarLista()"
                @voltarCronogramaRecebimento="voltarCronogramaRecebimento()">
            </rateios>
        </div>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnCronogramaRecebimento from "../cadastro/BtnCronogramaRecebimento.vue"
import BtnInserirCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnInserirCronogramaRecebimento.vue'
import BtnAtualizarCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnAtualizarCronogramaRecebimento.vue'
import BtnExcluirCronogramaRecebimento from '../cadastro/cronogramaRecebimento/BtnExcluirCronogramaRecebimento.vue'
import BtnMostrarRateios from '../cadastro/cronogramaRecebimento/BtnMostrarRateios'
import Rateios from '../cadastro/cronogramaRecebimento/rateios/Rateios'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnCronogramaRecebimento,
        BtnInserirCronogramaRecebimento,
        BtnAtualizarCronogramaRecebimento,
        BtnExcluirCronogramaRecebimento,
        BtnMostrarRateios,
        Rateios
    },

    data() {
        return {
            cronogramaRecebimento: [],
            comprometimento: null,
            itensSelecionados: [],
            erros: [],
            mostrarTabela: false,
            campos: [
                {
                    key: 'vcDescricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuParcela',
                    label: 'Parcela',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtMesAno',
                    label: 'Mês\\Ano',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuValorRecebimento',
                    label: 'Valor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'statusComprometimento',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center',
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        atualizarLista(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.cronogramaRecebimento = response.data.cronogramaRecebimento
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarComprometimento(comprometimento) {
            if (
                JSON.stringify(this.comprometimento) !=
                JSON.stringify(comprometimento)
            ) {
                this.atualizarLista()
            }
            this.comprometimento = comprometimento
        },

        voltarCronogramaRecebimento(){
            this.comprometimento = null;
        },

    },

    computed: {
        mostrarRateios() {
            return this.comprometimento !== null
        }
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.cronogramaRecebimento = this.convenio.cronogramaRecebimento
            }
        },

        comprometimento(n,o){
            this.comprometimento = n;
        }
    },
}
</script>
